import { render } from "./Team_manager_adviser_bar.vue?vue&type=template&id=15c5f5b4&scoped=true"
import script from "./Team_manager_adviser_bar.vue?vue&type=script&lang=js"
export * from "./Team_manager_adviser_bar.vue?vue&type=script&lang=js"

import "./Team_manager_adviser_bar.vue?vue&type=style&index=0&id=15c5f5b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15c5f5b4"

export default script